import { z } from 'zod';

const nullableOptionalString = z.string().nullable().optional();

export const oauthClientProfileRoleSchema = z.object({
  RoleInstanceId: nullableOptionalString,
});

// Schéma de validation runtime des profils client renvoyés par l'API OAuthClient.
export const oauthClientProfileSchema = z.object({
  InstanceId: z.string().min(1),
  Label: z.string(),
  Default: z.boolean(),
  Roles: z.array(oauthClientProfileRoleSchema).nullable().optional(),
});

export const oauthClientProfileListSchema = z.array(oauthClientProfileSchema);

// Schéma des rôles renvoyés par l'endpoint GetClientRoles.
export const oauthClientRoleSchema = z.object({
  InstanceId: z.string().min(1),
  Label: nullableOptionalString,
  DisplayOrder: z.number().nullable().optional(),
});

export const oauthClientRoleListSchema = z.array(oauthClientRoleSchema);

export type OAuthClientProfile = z.infer<typeof oauthClientProfileSchema>;
export type OAuthClientProfileRole = z.infer<typeof oauthClientProfileRoleSchema>;
export type OAuthClientRole = z.infer<typeof oauthClientRoleSchema>;
